var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"promoBadge d-flex justify-content-center align-items-center\" style=\"margin: 0px\">\n<i class=\"icon-eatselfapp_chevron flipH\"></i>\n<span>Promotion</span>\n<i class=\"icon-eatselfapp_chevron\"></i>\n</div>";
var id1="templates/promo-badge.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;